// src/components/Dashboard/EditProfile.jsx
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    TextField,
    Button,
    Alert,
    Stack,
} from "@mui/material";
import axios from "axios";

const EditProfile = ({ user, onCancel, onUserUpdate }) => {
    const [form, setForm] = useState({
        full_name: "",
        email: "",
        phone: "",
        gender: "",
        password: "",
        new_password: "",
        confirm_password: "",
    });
    const [message, setMessage] = useState("");
    const [formError, setFormError] = useState("");
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


    useEffect(() => {
        if (user) {
            setForm({
                full_name: user.full_name || "",
                email: user.email || "",
                phone: user.phone || "",
                gender: user.gender || "",
                password: "",
                new_password: "",
                confirm_password: "",
            });
        }
    }, [user]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        setFormError("");
        setMessage("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormError("");
        setMessage("");

        if ((form.new_password || form.confirm_password) && form.new_password !== form.confirm_password) {
            setFormError("New password and confirm password do not match.");
            return;
        }

        try {
            const token = localStorage.getItem("token");
            const payload = {
                full_name: form.full_name,
                email: form.email,
                phone: form.phone,
                gender: form.gender,
            };

            if (form.new_password) {
                payload.password = form.password;
                payload.new_password = form.new_password;
            }

            await axios.put(`${API_BASE_URL}/users/me`, payload, {
                headers: { Authorization: `Bearer ${token}` },
            });

            setMessage("Profile updated successfully!");
            onUserUpdate(payload);
            onCancel();
        } catch (err) {
            const detail = err.response?.data?.detail || "Update failed.";
            setFormError(typeof detail === "string" ? detail : JSON.stringify(detail));
        }
    };

    return (
        <Box maxWidth={600} mx="auto" p={4} boxShadow={3} borderRadius={2} bgcolor="background.paper">
            <Typography variant="h5" mb={3} textAlign="center">
                Edit Profile
            </Typography>

            {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
            {formError && <Alert severity="error" sx={{ mb: 2, whiteSpace: "pre-wrap" }}>{formError}</Alert>}

            <form onSubmit={handleSubmit}>
                <Stack spacing={2}>
                    <TextField
                        label="Full Name"
                        name="full_name"
                        value={form.full_name}
                        onChange={handleChange}
                        required
                        fullWidth
                    />
                    <TextField
                        label="Email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        required
                        fullWidth
                        type="email"
                    />
                    <TextField
                        label="Phone"
                        name="phone"
                        value={form.phone}
                        onChange={handleChange}
                        fullWidth
                    />
                    <TextField
                        label="Gender"
                        name="gender"
                        value={form.gender}
                        onChange={handleChange}
                        fullWidth
                        select
                        SelectProps={{ native: true }}
                    >
                        <option value="">None</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                    </TextField>

                    <TextField
                        label="Current Password"
                        name="password"
                        value={form.password}
                        onChange={handleChange}
                        type="password"
                        fullWidth
                        helperText="Required to change password"
                    />
                    <TextField
                        label="New Password"
                        name="new_password"
                        value={form.new_password}
                        onChange={handleChange}
                        type="password"
                        fullWidth
                    />
                    <TextField
                        label="Confirm New Password"
                        name="confirm_password"
                        value={form.confirm_password}
                        onChange={handleChange}
                        type="password"
                        fullWidth
                    />

                    <Button variant="contained" type="submit" fullWidth>
                        Save Changes
                    </Button>
                    <Button variant="outlined" fullWidth onClick={onCancel}>
                        Cancel
                    </Button>
                </Stack>
            </form>
        </Box>
    );
};

export default EditProfile;
